// extracted by mini-css-extract-plugin
module.exports = {"message_type_toggle":"CreateNewMessagePopup_message_type_toggle__y1hqm","messageTypeToggle":"CreateNewMessagePopup_message_type_toggle__y1hqm"};